const stages = [
  { id: 1, name: `Stage1`, sub: [1] },
  { id: 2, name: `Stage2`, sub: [2] },
  { id: 3, name: `Stage3`, sub: [3] },
  { id: 4, name: `Stage4`, sub: [4] },
  { id: 5, name: `Stage5`, sub: [5] },
  { id: 6, name: `Stage6`, sub: [6] },
]

const stageIds = stages.map(o => o.id)
const stageSubIds = stages.map(o => o.sub).flat()

export const resetAll = ({
  remove,
  updatePasses,
  updateHints,
  updateRole,
  updateSelectRole,
  updateVideo,
}: {
  remove: () => void
  updatePasses: (cb: (draft: any) => void) => void
  updateHints: (cb: (draft: any) => void) => void
  updateRole: (cb: () => string) => void
  updateSelectRole: (cb: () => boolean) => void
  updateVideo: (cb: () => boolean) => void
}) => {
  remove()
  updatePasses(draft => {
    // 清除所有通關紀錄
    stageSubIds.forEach(subId => {
      delete draft[`stage${subId}`]
    })
  })
  updateHints(draft => {
    // 清除所有提示紀錄
    stageIds.forEach(subId => {
      delete draft[`stage${subId}`]
    })
  })
  updateRole(() => '')
  updateSelectRole(() => false)
  updateVideo(() => false)
}
